import * as React from "react";
import {
  Box,
  Container,
  Grid,
  Heading,
  Stack,
  Text,
  SimpleGrid,
} from "@chakra-ui/react";
import Header from "components/reusables/Header/Header";
import Footer from "../Footer/Footer";

export const AboutCashQuin: React.FC = () => {
  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <>
      <Header />
      <Box
        bg="white"
        pt={{ base: 24, md: 28 }}
        pb={{ base: 12, md: 24 }}
        minH="100vh"
      >
        <Container maxW="6xl">
          <Stack gap={4} textAlign="center" mb={{ base: 12, md: 20 }}>
            <Heading as="h2" size="2xl" color="blue.600">
              About CashQuin
            </Heading>
            <Text fontSize="lg" color="gray.600" fontWeight="medium">
              Owned by{" "}
              <Text as="span" fontWeight="bold" color="gray.800">
                Webtooth Techno LLP
              </Text>
            </Text>

            <Text
              maxW="3xl"
              mx="auto"
              color="gray.600"
              fontSize="lg"
              lineHeight="relaxed"
              mt={4}
            >
              We are a team of passionate developers, designers, and strategists
              who believe in the power of technology to transform businesses.
              Our journey began with a simple idea: create digital solutions
              that not only solve real problems, but also inspire and engage
              customers.
            </Text>
          </Stack>

          <Grid
            templateColumns={{ base: "1fr", md: "1.2fr 0.8fr" }}
            gap={{ base: 10, md: 16 }}
            alignItems="start"
          >
            <Stack gap={8}>
              <Box
                bg="white"
                p={{ base: 8, md: 10 }}
                borderRadius="2xl"
                boxShadow="none"
                border="1px solid"
                borderColor="gray.100"
              >
                <Heading as="h3" size="lg" mb={4} color="gray.800">
                  Our Story
                </Heading>
                <Text fontSize="md" color="gray.600" lineHeight="1.8">
                  CashQuin was born from the need to make financial workflows
                  simpler, faster, and more secure. From day one, our focus has
                  been on building digital products that feel modern and
                  trustworthy — whether you&apos;re a startup, a growing
                  business, or an enterprise.
                </Text>
                <Text mt={4} fontSize="md" color="gray.600" lineHeight="1.8">
                  Today, we are a leading provider of digital solutions that
                  transform how businesses operate and engage with their
                  customers, with a strong focus on reliability and real-world
                  performance.
                </Text>
              </Box>

              <Box
                bg="white"
                p={{ base: 8, md: 10 }}
                borderRadius="2xl"
                boxShadow="none"
                border="1px solid"
                borderColor="gray.100"
              >
                <Heading as="h3" size="lg" mb={4} color="gray.800">
                  Our Mission
                </Heading>
                <Text fontSize="md" color="gray.600" lineHeight="1.8">
                  Our mission is simple:{" "}
                  <Text as="span" fontWeight="bold" color="blue.600">
                    To empower businesses with innovative technology solutions
                    that drive growth and success.
                  </Text>{" "}
                  We are committed to delivering high-quality, reliable, and
                  scalable platforms that help our clients achieve their
                  business goals.
                </Text>
              </Box>
            </Stack>

            <Stack gap={8}>
              <Box
                bg="white"
                p={{ base: 8, md: 10 }}
                borderRadius="2xl"
                boxShadow="none"
                border="1px solid"
                borderColor="gray.100"
                height="fit-content"
              >
                <Heading as="h3" size="lg" mb={6} color="gray.800">
                  What We Stand For
                </Heading>

                <SimpleGrid columns={{ base: 1, sm: 2, md: 1 }} gap={4} mb={6}>
                  {[
                    "Innovation",
                    "Integrity",
                    "Excellence",
                    "Security",
                    "Customer-Centricity",
                  ].map((item) => (
                    <Box key={item} display="flex" alignItems="center" gap={3}>
                      <Box w={2} h={2} borderRadius="full" bg="blue.500" />
                      <Text
                        fontSize="md"
                        fontWeight="semibold"
                        color="gray.700"
                      >
                        {item}
                      </Text>
                    </Box>
                  ))}
                </SimpleGrid>

                <Text fontSize="md" color="gray.500" fontStyle="italic">
                  Every product we ship and every integration we design is
                  guided by these principles — from architecture decisions to
                  the last pixel in the UI.
                </Text>
              </Box>
            </Stack>
          </Grid>
        </Container>
      </Box>
      <Footer />
    </>
  );
};
